export enum PlanningDayStatus {
	PAST = 'past',
	PLANNING = 'planning',
	PREVIEW = 'preview',
	PUBLISHED = 'published',
	OPEN = 'open',
	LOCKED = 'locked',
}
